<template>
  <div class="absolute inset-0 z-10 w-full h-full text-white group">
    <div
      class="absolute top-0 left-0 w-full opacity-0 transition-opacity group-hover_opacity-100"
      :class="{ 'opacity-100': showContent || showTopBar, 'h-full z-10': showContent }"
    >
      <div class="absolute top-0 left-0 z-10 w-full px-6 py-4 h-min-content" :class="[showContent ? 'bg-gray-900' : 'bg']">
        <slot name="top-bar" />
      </div>
      <div class="flex-grow w-full h-full bg backdrop-filter backdrop-blur-sm" :inert="!showContent" :class="{ 'opacity-0': !showContent }">
        <slot name="overlay" />
      </div>
    </div>
    <slot name="content" />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  showContent: {
    type: Boolean,
    default: false,
  },
  showTopBar: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="stylus" scoped>
.bg
  background rgba(34, 34, 34, 0.7)
</style>
